import { GiOrganigram } from "react-icons/gi";
import { FaBuilding, FaBuildingUser, FaUsers } from "react-icons/fa6";

export const supervisorLinks = [
	{ label: "Usuarios", path: "/usuarios", icon: FaUsers },
	{ label: "Rep Legales", path: "/clientes", icon: FaBuildingUser },
	{ label: "Empresas", path: "/empresa", icon: FaBuilding },
	{ label: "Organigrama", path: "/organigrama", icon: GiOrganigram },
];